import { getMappedEvents } from '../utils/getMappedEvents';

const EVENTS = [
  'newUserQuizShown',
  'newUserQuizQuestionAnswered',
  'newUserQuizSubmitFailed',
  'newUserQuizBypassed',
] as const;

export const newUserQuizEvents = getMappedEvents([...EVENTS], {
  shouldSendSubscriptionData: true,
});
